import React from 'react';
import { Section } from './ui/Section';
export function CostComparison() {
  const rows = [{
    sin: 'Meses sin saber cuánto vas a cobrar',
    costo: 'Tu estabilidad financiera pagando el precio'
  }, {
    sin: 'Clientes que no pagan y tú sin protocolo',
    costo: 'Horas de trabajo regaladas sin recuperar'
  }, {
    sin: 'Sin sistema de prospección',
    costo: 'Dependes de la suerte y las recomendaciones'
  }, {
    sin: 'Sin tarifa calculada',
    costo: 'Trabajas el doble por la mitad de lo que mereces'
  }, {
    sin: 'Sin contrato blindado',
    costo: 'Cada proyecto puede convertirse en una pesadilla'
  }, {
    sin: 'Sin dashboard de control',
    costo: 'Tu negocio vive en tu cabeza y eso agota'
  }, {
    sin: 'El próximo mes igual que este',
    costo: 'El mismo ciclo — el próximo trimestre también'
  }];
  return <Section data-id="element-64">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-65">
        ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
      </h2>

      <div className="bg-brand-card border border-neutral-800 rounded-2xl overflow-hidden max-w-4xl mx-auto mb-12" data-id="element-66">
        <div className="overflow-x-auto" data-id="element-67">
          <table className="w-full min-w-[600px] border-collapse" data-id="element-68">
            <thead data-id="element-69">
              <tr className="bg-neutral-900" data-id="element-70">
                <th className="text-left p-5 border-b border-neutral-800 text-neutral-400 font-medium w-1/2" data-id="element-71">
                  Sin MegaPack™
                </th>
                <th className="text-left p-5 border-b border-neutral-800 text-red-400 font-medium w-1/2" data-id="element-72">
                  Coste real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-73">
              {rows.map((row, i) => <tr key={i} className="border-b border-neutral-800/50 last:border-0 hover:bg-neutral-900/50 transition-colors" data-id="element-74">
                  <td className="p-5 text-neutral-300" data-id="element-75">{row.sin}</td>
                  <td className="p-5 text-neutral-500" data-id="element-76">{row.costo}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="text-center" data-id="element-77">
        <p className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-78">
          El próximo mes puede ser diferente.
        </p>
        <p className="text-xl text-brand-accent italic" data-id="element-79">
          "El próximo cliente puede ser el primero que llegue por tu sistema, no
          por suerte." 💪
        </p>
      </div>
    </Section>;
}